// import { gsap } from "gsap"
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// const { $ } = window

//@scroll-trigger intersection observer

export default {
	init() {
		// gsap.registerPlugin(ScrollTrigger)
      
      // console.log(ajaxInfo.ajax_url)
      handleProfileImg()
      handleUserInfoUpdate()
      handleUserPwdUpdate()
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}
function handleProfileImg() {
   let $changeLink = $('#editProfImg')
   let $acctAvatar = $('.acct-avatar')
   let $edit  = $('.wp-user-profile-avatar-upload')
   let $updateBtn  = $('#wp_user_profile_avatar_update_profile')
   let $closeBtn  = $('#doneBtn')

   $('tr:first-child td p:nth-child(2)').text('or upload new image')
   
   $acctAvatar.on('click', e => {
      e.preventDefault()
      $changeLink.hide()
      $acctAvatar.hide()
      $edit.show()
      $closeBtn.show()
   })
   $changeLink.on('click', e => {
      e.preventDefault()
      $changeLink.hide()
      $acctAvatar.hide()
      $edit.show()
      $closeBtn.show()
   })

   $closeBtn.on('click', e => {
      e.preventDefault()
      // $changeLink.show()
      // $acctAvatar.show()
      // $edit.hide()
      setTimeout("location.reload(true);", 200);
   })
}

function signalFailed($form) {
   let $p = $form.find('.message')
   let text = $p.text()
   $p.text('Not updated. Please try again.')
   $p.addClass('show')
   setTimeout(() => {
      $p.removeClass('show')
      $p.text(text)
   }, 7000)
}

async function getToken($form) {
   let token = await fetch('/wp-json/bvin/v1/gentoken')
                     .then(res => res.json())
                     .then(data => { return data['token'];})
                     .catch(err => console.log(err)) //TODO

   if(typeof(token) === 'undefined') {
      signalFailed($form)
   }
   return token
}

function sendRequest(data, $form) {
   $.ajax({
      type: 'POST',
      url: ajaxInfo.ajax_url,
      dataType: 'json',
      data,
      success: function(res) {
         console.log(res)
         let $p = $form.find('.message')
         $p.addClass('show')
         setTimeout(() => {
            $p.removeClass('show')
         }, 7000)
         
         if(res.status !== 200) {
            //throw `non-200 success`;
            // ${JSON.strigify(data)}`;
            console.log(res)
            signalFailed($form)
         }
      },
      error: function(err) {
         signalFailed($form)
         console.error(err);
      }
   })
}

function handleUserInfoUpdate() {
   let $form = $('#form-user-info')
   
   $('#form-user-info .form-submit').hide()
   $('#form-user-info input').on('blur', () => {
   $('#form-user-info .form-submit').show()
   })

   $form.on('submit', async function(e) {
      e.preventDefault()
      
      let email = $form.find('#email-address')[0].value
      let firstName = $form.find('#first-name')[0].value
      let lastName = $form.find('#last-name')[0].value
      let organization = $form.find('#organization')[0].value
      let title = $form.find('#title')[0].value
      let linkedin = $form.find('#linkedin')[0].value
      let twitter = $form.find('#twitter')[0].value

      let token = await getToken($form)
      if(!token) return

      let data = {
         action: 'update_user_info',
         security: token,
         email,
         firstName,
         lastName,
         organization,
         title,
         linkedin,
         twitter,
      }
      console.log(data)

      sendRequest(data,$form);
   })
}
function handleUserPwdUpdate() { 
   let $form = $('#form-pwd') //$('.acct-pswd form')

   $form.on('submit', async function(e) {
      e.preventDefault()
      
      let old = $form.find('#old-password')[0].value
      let newPwd = $form.find('#new-password')[0].value
      let confirm = $form.find('#confirm-password')[0].value

      let token = await getToken($form)
      if(!token) return

      
      let data = {
         action: 'update_pwd',
         security: token,
         old,
         newPwd,
         confirm 
      }
      
      sendRequest( data, $form );
   })

}